import { npiValidator } from "./npi";

/**
 * Creates an NPI validator for antd Form.Item
 * @param {string} requiredMessage - Error message when NPI is empty
 * @param {string} formatMessage - Error message when NPI format is invalid
 * @returns {Function} Validator function for antd Form.Item rules
 */
export const createNpiValidator = (requiredMessage, formatMessage) => (_, value) => {
  if (!value) {
    return Promise.reject(new Error(requiredMessage));
  }
  if (!npiValidator(value)) {
    return Promise.reject(new Error(formatMessage));
  }
  return Promise.resolve();
};

/**
 * Creates an email validator for antd Form.Item
 * @param {string} invalidMessage - Error message when email format is invalid
 * @returns {Function} Validator function for antd Form.Item rules
 */
export const createEmailValidator = (invalidMessage) => (_, value) => {
  if (!value) {
    return Promise.resolve(); // Email is optional
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return Promise.reject(new Error(invalidMessage));
  }
  return Promise.resolve();
};

/**
 * Creates a 5-digit US zip code validator for antd Form.Item (empty = valid, field is optional)
 * @param {string} formatMessage - Error message when the value is not exactly 5 digits
 */
export const createZipCodeValidator = (formatMessage) => (_, value) => {
  if (!value) return Promise.resolve();
  return /^\d{5}$/.test(String(value)) ? Promise.resolve() : Promise.reject(new Error(formatMessage));
};

/**
 * Creates a 10-digit US phone validator for antd Form.Item (empty = valid, field is optional).
 * Formatting characters are ignored — only the digit count matters.
 * @param {string} formatMessage - Error message when the value does not contain exactly 10 digits
 */
export const createPhoneNumberValidator = (formatMessage) => (_, value) => {
  if (!value) return Promise.resolve();
  return String(value).replace(/\D/g, "").length === 10 ? Promise.resolve() : Promise.reject(new Error(formatMessage));
};
